import api from "./api";
import {API_URL_VERSION} from "../constants/environment";
import {toSearchFilter} from "../utils";

export const ENDPOINT_AGENT_SCHEDULES_LIST = API_URL_VERSION + 'escalas-agentes/listar'
export const ENDPOINT_AGENT_SCHEDULES = API_URL_VERSION + 'escalas-agentes'
export const ENDPOINT_AGENT_SCHEDULES_GET_DETAIL_UPDATE_DELETE = API_URL_VERSION + 'escalas-agentes/'

export const agentScheduleService = {
    list: async (params) => {
        try {
            const response = await api.post(ENDPOINT_AGENT_SCHEDULES_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "settings.agent-schedule.messages.error.list");
            return []
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_AGENT_SCHEDULES, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "settings.agent-schedule.messages.error.create");
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_AGENT_SCHEDULES_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "settings.agent-schedule.messages.error.find");
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_AGENT_SCHEDULES_GET_DETAIL_UPDATE_DELETE}${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "settings.agent-schedule.messages.error.update");
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_AGENT_SCHEDULES_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "settings.agent-schedule.messages.error.delete");
        }
    },

};
